export const globalData = (state) => state.ProspectWidgets_GlobalData;
export const bussData = (state) => state.ProspectWidgets_BussProductsData
